import type { GetNotificationSettings200Frequency } from './getNotificationSettings200Frequency';
import type { GetNotificationSettings200TypeSettings } from './getNotificationSettings200TypeSettings';

export type GetNotificationSettings200 = {
  emailEnabled?: boolean;
  frequency?: GetNotificationSettings200Frequency;
  inAppEnabled?: boolean;
  pushEnabled?: boolean;
  /** @nullable */
  quietHoursEnd?: string | null;
  /** @nullable */
  quietHoursStart?: string | null;
  smsEnabled?: boolean;
  typeSettings?: GetNotificationSettings200TypeSettings;
  userId: string;
};
